// extracted by mini-css-extract-plugin
export default {"CardsContainer":"RelatedCases_CardsContainer__SjXF0","InnerContainer":"RelatedCases_InnerContainer__5uuHQ","Title":"RelatedCases_Title__2oVrD"};